import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/useAuth';
import { Loader2 } from 'lucide-react'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    )
  }

  if (!isAuthenticated) {
    // Store the attempted URL for redirecting back after login
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
} 